/* Mr. Airco concept 2026 – v2 aanvullingen */
(function () {
  'use strict';
  /* Sticky header: verbergen bij omlaag scrollen, tonen bij omhoog scrollen */
  function initSticky() {
    var hdr = document.querySelector('.mra-header');
    if (!hdr) return;
    var wrap = hdr.closest('.shopify-section-group-header-group') || hdr.closest('.shopify-section') || hdr;
    if (wrap.__mraSticky) return; wrap.__mraSticky = true;
    wrap.classList.add('mra-stickyhdr');
    var last = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY, h = wrap.offsetHeight;
      wrap.classList.toggle('is-scrolled', y > 8);
      wrap.style.setProperty('--mra-hdr-top', hdr.offsetTop + 'px');
      wrap.classList.toggle('is-compact', y > h + 40);
      if (y > h && y > last + 4) wrap.classList.add('is-hidden');
      else if (y < last - 4 || y <= h) wrap.classList.remove('is-hidden');
      if (wrap.contains(document.activeElement)) wrap.classList.remove('is-hidden');
      last = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }, { passive: true });
    wrap.addEventListener('focusin', function () { wrap.classList.remove('is-hidden'); });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
  /* Ankerlinks (#offerte e.d.): soepel naar het doel scrollen met ruimte voor de header.
     Voorkomt dat de browser een overflow:hidden-blok (zoals de hero) intern laat verschuiven. */
  function unclip(t) {
    for (var el = t.parentElement; el && el !== document.body; el = el.parentElement) {
      if (el.scrollTop || el.scrollLeft) { var cs = getComputedStyle(el); if (cs.overflowY === 'hidden' || cs.overflowX === 'hidden' || cs.overflowY === 'clip') { el.scrollTop = 0; el.scrollLeft = 0; } }
    }
  }
  function goTo(t, smooth) {
    unclip(t);
    var hdr = document.querySelector('.mra-stickyhdr');
    var top = t.getBoundingClientRect().top + window.scrollY;
    var down = top - 16 > window.scrollY;
    var vis = hdr ? hdr.offsetHeight - (top > hdr.offsetHeight * 2 ? (parseInt(hdr.style.getPropertyValue('--mra-hdr-top'), 10) || 0) : 0) : 0;
    var off = (down && top > (hdr ? hdr.offsetHeight : 0) * 2 ? 0 : vis) + 16;
    var y = top - off;
    if (y < 160) y = 0;
    if (down && hdr) hdr.classList.add('is-hidden');
    window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest('a[href*="#"]'); if (!a || a.hasAttribute('data-mra-kit-open') || a.getAttribute('role') === 'tab') return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
    if (u.pathname !== location.pathname || u.search !== location.search || u.hash.length < 2) return;
    var t = document.getElementById(decodeURIComponent(u.hash.slice(1))); if (!t) return;
    e.preventDefault();
    goTo(t, true);
    try { history.replaceState(null, '', u.hash); } catch (_) {}
    setTimeout(function () { unclip(t); var f = t.querySelector('input:not([type=hidden]):not([type=radio]),select,textarea'); if (f && window.matchMedia('(min-width:721px)').matches) f.focus({ preventScroll: true }); }, 700);
  });
  window.addEventListener('load', function () { if (location.hash.length > 1) { var t = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (t) setTimeout(function () { goTo(t, false); }, 50); } });

  document.addEventListener('shopify:section:load', initSticky);

  /* Upsells op de productpagina: '+ Voeg toe' zet het artikel direct in de winkelwagen.
     Leidingsets bij duo/triple: per binnenunit een eigen lengte. */
  (function () {
    var st = document.createElement('style');
    st.textContent = '.mra-up__lens{display:flex;flex-wrap:wrap;gap:6px 12px}.mra-up__lens label{display:inline-flex;align-items:center;gap:6px}.mra-up__toggle.is-done{background:var(--mra-green,#1F9D55)!important;color:#fff!important;border-color:transparent!important}';
    document.head.appendChild(st);
  })();
  function upSum(u) {
    var sels = u.querySelectorAll('[data-mra-up-len]'); if (!sels.length) return;
    var t = 0; sels.forEach(function (s) { var o = s.options[s.selectedIndex]; t += Number(o && o.getAttribute('data-price') || 0); });
    var pe = u.querySelector('[data-mra-up-price]'); if (pe) { pe.setAttribute('data-cents', t); }
    u.setAttribute('data-price', t);
    if (window.mraApplyBtw) window.mraApplyBtw();
  }
  function allPipes() { document.querySelectorAll('.mra-up--pipes').forEach(upSum); }
  document.addEventListener('change', function () { setTimeout(allPipes, 0); });
  document.addEventListener('input', function () { setTimeout(allPipes, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(allPipes, 60); }); else setTimeout(allPipes, 60);
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mra-up-toggle]'); if (!t) return;
    var u = t.closest('[data-mra-up]'); if (!u || !window.mraAddItems) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var map = {}, order = [];
    var sels = u.querySelectorAll('select');
    if (sels.length) sels.forEach(function (s) { var id = Number(s.value); if (!map[id]) { map[id] = 0; order.push(id); } map[id]++; });
    else { var id0 = Number(u.getAttribute('data-id')); map[id0] = 1; order.push(id0); }
    var items = order.map(function (id) { return { id: id, quantity: map[id] }; });
    var label = t.textContent; t.disabled = true; t.textContent = 'Bezig…';
    window.mraAddItems(items).then(function () {
      t.classList.add('is-done'); t.textContent = '✓ Toegevoegd';
      setTimeout(function () { t.classList.remove('is-done'); t.textContent = label; t.disabled = false; }, 2500);
    }).catch(function (err) {
      t.textContent = label; t.disabled = false;
      var root = u.closest('[data-mra-pdp]'); var msg = root && root.querySelector('[data-mra-atc-msg]');
      if (msg) { msg.className = 'mra-msg mra-msg--err'; msg.textContent = err.message; msg.hidden = false; } else alert(err.message);
    });
  }, true);
})();
